module.exports = __webpack_public_path__ + "static/media/ProximaNovaAlt.b069a18a.ttf";